import { useAppStore } from '@/store/appStore';

/**
 * Mostra una notifica toast
 * @param message - Il messaggio da mostrare
 * @param type - Il tipo di toast (success, error, info)
 * @param duration - Durata in millisecondi (default: 4000)
 * @param action - Azione opzionale con label e onClick callback
 * @param undoId - ID opzionale dell'azione di undo associata al toast
 */
export function toast(
  message: string,
  type: 'success' | 'error' | 'info' = 'info',
  duration?: number,
  action?: {
    label: string;
    onClick: () => void;
  },
  undoId?: string
) {
  useAppStore.getState().addToast(message, type, duration, action, undoId);
}

// Funzioni helper per i vari tipi
export const toastSuccess = (message: string, duration?: number) => 
  toast(message, 'success', duration);

export const toastError = (message: string, duration?: number) => 
  toast(message, 'error', duration);

export const toastInfo = (message: string, duration?: number) => 
  toast(message, 'info', duration);

